<template>
  <div class="auth-description spacey-32">
    <h2 class="auth-title">{{ $t('Do you work in') }} “{{ company }}” {{ $t('company') }}?</h2>
    <span class="text text-grey">
      {{ $t('We found out') }}
      “{{ company }}”
      {{
        $t(
          'company is already registered in Fixtender. Click “Yes” and we add you to your team or click “No” and create new company instead'
        )
      }}
    </span>

    <Teammates v-if="teammates.members.length" :company="company" :teammates="teammates.members" />

    <Form @submit="finishRegistration">
      <div class="choose-company__buttons-container spacex-12">
        <Button action-type="submit">
          {{ $t('Yes') }}
        </Button>
        <Button color="neutral" @click="nextStep">
          {{ $t('No') }}
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import { mapActions, mapState } from 'vuex';
  import Teammates from '@/components/info/Teammates';
  import factory from '@/utils/api/factory';
  import Form from '@/components/common/Form';

  export default {
    name: 'ChooseCompany',
    components: {
      Button,
      Form,
      Teammates,
    },
    data() {
      return {
        teammates: {
          name: '',
          members: [],
        },
      };
    },
    async created() {
      await this.getTeammates();
    },
    computed: {
      ...mapState('auth', ['registrationInfo', 'password']),
      company() {
        return this.teammates.name;
      },
    },
    methods: {
      ...mapActions('auth', ['login']),
      async getTeammates() {
        try {
          const { data } = await factory('register').indexInPath('teammates');

          this.teammates = data;
        } catch (e) {
          if (e.response?.status === 404) this.$emit('change-step', 2.1);
          else console.error(e);
        }
      },
      async finishRegistration() {
        try {
          await factory('register').postInPath('finish');

          await this.login({
            email: this.registrationInfo.email,
            password: this.password,
          });

          await this.$router.push({ name: 'projects' });
          location.reload();
        } catch (e) {
          console.error(e);
        }
      },
      nextStep() {
        this.$emit('change-step', 2.1);
      },
    },
  };
</script>
